export interface PhoneNumber {
  id: string;
  phone_number: string;
  type: "inbound" | "outbound";
  endpoint_url?: string;
  termination_sip_domain?: string;
  auth_username?: string;
  auth_password?: string;
  organization_id: string;
  created_at?: string;
  created_by?: string;
  updated_at?: string;
}

export interface PhoneNumberFormData {
  phone_number: string;
  type: "inbound" | "outbound";
  endpoint_url?: string;
  termination_sip_domain?: string;
  auth_username?: string;
  auth_password?: string;
}

export const isValidE164 = (phoneNumber: string): boolean => {
  // E.164 format: + followed by up to 15 digits
  // Allow spaces and dashes for user input flexibility
  const normalizedNumber = phoneNumber.replace(/[\s-]/g, "");
  const e164Regex = /^\+[1-9]\d{1,14}$/;
  return e164Regex.test(normalizedNumber);
};
